// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V3Lc","comment":"styles_comment__sZk7R"};